// extracted by mini-css-extract-plugin
export default {"header":"Stats_header__fJaHX","name":"Stats_name__N0iC1","buttons":"Stats_buttons__1TdVf","main":"Stats_main__TD7TJ"};